import { render, staticRenderFns } from "./distribution-diagram.vue?vue&type=template&id=e4a0f1b4&"
import script from "./distribution-diagram.vue?vue&type=script&lang=js&"
export * from "./distribution-diagram.vue?vue&type=script&lang=js&"
import style0 from "./distribution-diagram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports